module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 62
// module chunks = 0